import { IGlobalStore } from 'modules/types';

export const getGuestUserState = ( { guestUser }: IGlobalStore ) => guestUser;